/* #ifndefall OPEN-SOURCE
 * 物流管理
 */
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
import EmptyRouter from '@/layout/EmptyRouter.vue';
export default {
  path: 'logistics',
  name: 'SettingLogistics',
  component: EmptyRouterAlive,
  meta: {
    title: '物流',
  },
  children: [
    {
      path: 'strategy',
      name: 'SettingLogisticsStrategy',
      redirect: 'strategy/config',
      component: EmptyRouter,
      meta: {
        title: '物流策略',
      },
      children: [
        {
          path: 'config',
          name: 'SettingLogisticsStrategy',
          component: () => import('@/views/center-setting/logistics/strategy/config.vue'),
          meta: {
            title: '物流策略',
          },
        },
        /**     ****** 设置订单金额    ******** */
        {
          path: 'orderMoney',
          name: 'SettingLogisticsStrategyOrderMoneyIndex',
          component: () => import('@/views/center-setting/logistics/strategy/orderMoney'),
          meta: {
            title: '设置订单金额',
          },
          hidden: true,
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'SettingLogisticsStrategyOrderMoneyIndex_Add',
          meta: { title: '新增订单金额', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingLogisticsStrategyOrderMoneyIndex_Edit',
          meta: { title: '编辑订单金额' },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingLogisticsStrategyOrderMoneyIndex_Status',
          meta: { title: '启用/禁用订单金额' },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingLogisticsStrategyOrderMoneyIndex_Delete',
          meta: { title: '删除订单金额' },
          hidden: true,
        },
        /** 按钮权限end */
        /**     ****** 设置指定商品    ******** */
        {
          path: 'assignGoods',
          name: 'SettingLogisticsStrategyAssignGoodsIndex',
          component: () => import('@/views/center-setting/logistics/strategy/assignGoods'),
          meta: {
            title: '设置指定商品',
          },
          hidden: true,
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'SettingLogisticsStrategyAssignGoodsIndex_Add',
          meta: { title: '新增商品', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingLogisticsStrategyAssignGoodsIndex_Edit',
          meta: { title: '编辑商品' },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingLogisticsStrategyAssignGoodsIndex_Status',
          meta: { title: '启用/禁用商品' },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingLogisticsStrategyAssignGoodsIndex_Delete',
          meta: { title: '删除商品' },
          hidden: true,
        },
        /** 按钮权限end */
        /**     ****** 设置省市区    ******** */
        {
          path: 'zones',
          name: 'SettingLogisticsStrategyZonesIndex',
          component: () => import('@/views/center-setting/logistics/strategy/zones'),
          meta: {
            title: '设置省市区',
          },
          hidden: true,
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'SettingLogisticsStrategyZonesIndex_Add',
          meta: { title: '新增省市区', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingLogisticsStrategyZonesIndex_Edit',
          meta: { title: '编辑省市区' },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingLogisticsStrategyZonesIndex_Status',
          meta: { title: '启用/禁用省市区' },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingLogisticsStrategyZonesIndex_Delete',
          meta: { title: '删除省市区' },
          hidden: true,
        },
        /** 按钮权限end */
        /**     ****** 设置仓库    ******** */
        {
          path: 'warehouse',
          name: 'SettingLogisticsStrategyWarehouseIndex',
          component: () => import('@/views/center-setting/logistics/strategy/warehouse'),
          meta: {
            title: '设置仓库',
          },
          hidden: true,
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'SettingLogisticsStrategyWarehouseIndex_Add',
          meta: { title: '新增仓库', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingLogisticsStrategyWarehouseIndex_Edit',
          meta: { title: '编辑仓库' },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingLogisticsStrategyWarehouseIndex_Status',
          meta: { title: '启用/禁用仓库' },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingLogisticsStrategyWarehouseIndex_Delete',
          meta: { title: '删除仓库' },
          hidden: true,
        },
        /** 按钮权限end */
      ],
    },
    {
      path: 'authorize',
      name: 'SettingLogisticsStrategyAuthorize',
      redirect: 'authorize/index',
      component: EmptyRouter,
      meta: {
        title: '物流授权',
      },
      children: [
        {
          path: 'index',
          name: 'SettingLogisticsStrategyAuthorize',
          component: () => import('@/views/center-setting/logistics/authorize'),
          meta: {
            title: '物流授权',
          },
        },
      ],
    },
  ],
};
